var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 121.2900 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6445-2.19727C92.041-2.19727 113.477-27.3438 113.477-35.2051C113.477-43.1152 92.041-68.2129 60.6445-68.2129C29.7363-68.2129 7.8125-43.1152 7.8125-35.2051C7.8125-27.3438 29.7363-2.19727 60.6445-2.19727ZM60.6445-9.0332C35.9863-9.0332 15.3809-29.9316 15.3809-35.2051C15.3809-39.4531 35.9863-61.377 60.6445-61.377C85.2539-61.377 105.859-39.4531 105.859-35.2051C105.859-29.9316 85.2539-9.0332 60.6445-9.0332ZM60.6445-13.8184C72.5098-13.8184 82.1289-23.4375 82.1289-35.3027C82.1289-47.168 72.5098-56.7871 60.6445-56.7871C48.7793-56.7871 39.1602-47.168 39.1602-35.3027C39.1602-23.4375 48.7793-13.8184 60.6445-13.8184ZM60.6445-27.9785C56.6406-27.9785 53.3691-31.25 53.3691-35.2539C53.3691-39.2578 56.6406-42.5293 60.6445-42.5293C64.6973-42.5293 67.9199-39.2578 67.9199-35.2539C67.9199-31.25 64.6973-27.9785 60.6445-27.9785Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c2052a8a52894c09e275efa419774906.svg";
export { ForwardRef as ReactComponent };